module.exports = __webpack_public_path__ + "img/index1.e05fce82.png";